import styled from '@emotion/styled'

export const PageWrapper = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 380px);
  align-items: start;
  gap: 24px;
  min-height: 100%;
  width: 100%;
  position: relative;
  background: transparent;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`
